/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountReceivable } from '../models/AccountReceivable';
import type { AccountReceivablePaginatedResponse } from '../models/AccountReceivablePaginatedResponse';
import type { CreateAccountReceivableCommentResponse } from '../models/CreateAccountReceivableCommentResponse';
import type { CreateAccountReceivableViaCSVResponse } from '../models/CreateAccountReceivableViaCSVResponse';
import type { CreateAccountReceivableViaOCRMultipleResponse } from '../models/CreateAccountReceivableViaOCRMultipleResponse';
import type { CreateAccountReceivableViaOCRResponse } from '../models/CreateAccountReceivableViaOCRResponse';
import type { CreateAccountReceivableWithCustomerRequest } from '../models/CreateAccountReceivableWithCustomerRequest';
import type { CreateAccountReceivableWithCustomerResponse } from '../models/CreateAccountReceivableWithCustomerResponse';
import type { GetAccountReceivableResponse } from '../models/GetAccountReceivableResponse';
import type { MoveAccountReceivablesRequest } from '../models/MoveAccountReceivablesRequest';
import type { SyncInvoicesFromQuickbooksRequest } from '../models/SyncInvoicesFromQuickbooksRequest';
import type { SyncInvoicesFromQuickbooksResponse } from '../models/SyncInvoicesFromQuickbooksResponse';
import type { SyncInvoicesFromStripeRequest } from '../models/SyncInvoicesFromStripeRequest';
import type { SyncInvoicesFromStripeResponse } from '../models/SyncInvoicesFromStripeResponse';
import type { UpdateAccountReceivableRequest } from '../models/UpdateAccountReceivableRequest';
import type { UpdateAccountReceivableResponse } from '../models/UpdateAccountReceivableResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AccountReceivablesService {

    /**
     * @param commentId
     * @param attachmentId
     * @returns string OK
     * @throws ApiError
     */
    public static getAttachmentSignedUrl(
        commentId: string,
        attachmentId: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/accountreceivables/comment/{commentId}/attachment/{attachmentId}/signed-url',
            path: {
                'commentId': commentId,
                'attachmentId': attachmentId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * @param commentId
     * @param attachmentId
     * @returns string OK
     * @throws ApiError
     */
    public static getAttachmentThumbnailSignedUrl(
        commentId: string,
        attachmentId: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/accountreceivables/comment/{commentId}/attachment/{attachmentId}/thumbnail-signed-url',
            path: {
                'commentId': commentId,
                'attachmentId': attachmentId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Creates a stripe subscription for the organization. This will create a new
     * subscription in stripe and return the subscription ID.
     * @returns any OK
     * @throws ApiError
     */
    public static churnedAccounts(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/stripe/churnedaccounts',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Creates a stripe subscription for the organization. This will create a new
     * subscription in stripe and return the subscription ID.
     * @returns any OK
     * @throws ApiError
     */
    public static churnRecoveredAccounts(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/stripe/churnrecoveredaccounts',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Creates a new workspace.
     * @param accountreceivableId The ID of the account receivable to create a comment for.
     * @param formData
     * @returns CreateAccountReceivableCommentResponse OK
     * @throws ApiError
     */
    public static createAccountReceivableComment(
        accountreceivableId: string,
        formData?: {
            commentText: string;
            files?: Array<Blob>;
        },
    ): CancelablePromise<CreateAccountReceivableCommentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accountreceivables/{accountreceivableId}/comment',
            path: {
                'accountreceivableId': accountreceivableId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Creates a new workspace.
     * @param requestBody The request to create a workspace.
     * @returns CreateAccountReceivableWithCustomerResponse OK
     * @throws ApiError
     */
    public static createAccountReceivableWithCustomer(
        requestBody?: CreateAccountReceivableWithCustomerRequest,
    ): CancelablePromise<CreateAccountReceivableWithCustomerResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accountreceivables/create/withCustomer',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Processes a CSV file containing account receivable data entirely via Vertex AI.
     * The CSV file should have one header row and multiple data rows.
     * @param formData
     * @returns CreateAccountReceivableViaCSVResponse OK
     * @throws ApiError
     */
    public static createAccountReceivableViaCsv(
        formData?: {
            portfolioId: string;
            file: Blob;
        },
    ): CancelablePromise<CreateAccountReceivableViaCSVResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accountreceivables/create/viaCSV',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * Creates a new Account Receivable via OCR using Vertex AI.
     * Accepts a single image or PDF file as multipart/form-data.
     * @param formData
     * @returns CreateAccountReceivableViaOCRResponse OK
     * @throws ApiError
     */
    public static createAccountReceivableViaOcr(
        formData?: {
            portfolioId: string;
            file: Blob;
        },
    ): CancelablePromise<CreateAccountReceivableViaOCRResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accountreceivables/create/viaOCR',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * Creates new Account Receivables via OCR for multiple files using Vertex AI.
     * Accepts multiple image or PDF files as multipart/form-data.
     * @param formData
     * @returns CreateAccountReceivableViaOCRMultipleResponse OK
     * @throws ApiError
     */
    public static createAccountReceivableViaOcrMultiple(
        formData?: {
            portfolioId: string;
            files: Array<Blob>;
        },
    ): CancelablePromise<CreateAccountReceivableViaOCRMultipleResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accountreceivables/create/viaOCR/multiple',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * Deletes the specified accountreceivable.
     * @param accountreceivableId The ID of the accountreceivable to run.
     * @returns any OK
     * @throws ApiError
     */
    public static deleteAccountReceivable(
        accountreceivableId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/accountreceivables/{accountreceivableId}/delete',
            path: {
                'accountreceivableId': accountreceivableId,
            },
        });
    }

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static deleteMultipleAccountReceivables(
        requestBody?: Array<string>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accountreceivables/delete-multiple',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Retrieve all accountreceivables for the specified workspace, excluding those created via the external API.
     * @param accountreceivableId The ID of the accountreceivable to retrieve.
     * @returns GetAccountReceivableResponse OK
     * @throws ApiError
     */
    public static getAccountReceivable(
        accountreceivableId: string,
    ): CancelablePromise<GetAccountReceivableResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/accountreceivables/{accountreceivableId}/details',
            path: {
                'accountreceivableId': accountreceivableId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static moveAccountReceivables(
        requestBody?: MoveAccountReceivablesRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accountreceivables/move',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Retrieve all invoices from Stripe for the specified workspace.
     * @param requestBody The request containing sync details.
     * @returns SyncInvoicesFromStripeResponse OK
     * @throws ApiError
     */
    public static syncInvoicesFromStripe(
        requestBody?: SyncInvoicesFromStripeRequest,
    ): CancelablePromise<SyncInvoicesFromStripeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accountreceivables/syncfromstripe',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Retrieve all accountreceivables for the specified workspace, excluding those created via the external API.
     * @param requestBody The ID of the accountreceivable to retrieve.
     * @returns SyncInvoicesFromQuickbooksResponse OK
     * @throws ApiError
     */
    public static syncInvoicesFromQuickbooks(
        requestBody?: SyncInvoicesFromQuickbooksRequest,
    ): CancelablePromise<SyncInvoicesFromQuickbooksResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accountreceivables/syncfromquickbooks',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Creates a new workspace.
     * @param accountReceivableId The ID of the account receivable to update.
     * @param requestBody The request to create a workspace.
     * @returns UpdateAccountReceivableResponse OK
     * @throws ApiError
     */
    public static updateAccountReceivable(
        accountReceivableId: string,
        requestBody?: UpdateAccountReceivableRequest,
    ): CancelablePromise<UpdateAccountReceivableResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/accountreceivables/{accountReceivableId}/update',
            path: {
                'accountReceivableId': accountReceivableId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Retrieve all accountreceivables for the specified workspace, excluding those created via the external API.
     * @param portfolioId The ID of the portfolio to scope the accountreceivables for.
     * @param page The page number (1-based)
     * @param pageSize The number of items per page
     * @returns AccountReceivablePaginatedResponse OK
     * @throws ApiError
     */
    public static getAccountReceivables(
        portfolioId: string,
        page: number = 1,
        pageSize: number = 10,
    ): CancelablePromise<AccountReceivablePaginatedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/accountreceivables/{portfolioId}',
            path: {
                'portfolioId': portfolioId,
            },
            query: {
                'page': page,
                'pageSize': pageSize,
            },
        });
    }

    /**
     * @param portfolioId
     * @returns AccountReceivable OK
     * @throws ApiError
     */
    public static getAllAccountReceivables(
        portfolioId: string,
    ): CancelablePromise<Array<AccountReceivable>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/accountreceivables/{portfolioId}/all',
            path: {
                'portfolioId': portfolioId,
            },
        });
    }

}
